export default __webpack_public_path__ + "static/media/notify.640a5c63.mp3";